export const defaultApiErrorMessage = () => {
    const isConnected = navigator.onLine;
    const title = isConnected ? 'Service Temporarily Unavailable' : 'No Internet Connection';
    const message = isConnected
        ? "There seems to have been a hiccup. We've reported the issue. Please try again later."
        : 'Please check your connection settings and try again.';

    return {
        title,
        message,
    };
};
